import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Nav from './components/Nav';
import Hero from './components/Hero';
import SocialProof from './components/SocialProof';
import TwoAudiences from './components/TwoAudiences';
import SteelSupply from './components/SteelSupply';
import HowItWorksSection from './components/HowItWorks';
import Services from './components/Services';
import Pricing from './components/Pricing';
import SubmitForm from './components/SubmitForm';
import Manufacturers from './components/Manufacturers';
import FAQ from './components/FAQ';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';
import MobileStickyCTA from './components/MobileStickyCTA';
import HowItWorksPage from './HowItWorks';
import Blog from './Blog';
import HowToGetCustomMetalParts from './blog/HowToGetCustomMetalParts';
import CustomMetalFabricationCost from './blog/CustomMetalFabricationCost';
import PrototypeMetalProduct from './blog/PrototypeMetalProduct';
import SheetMetalVsCNC from './blog/SheetMetalVsCNC';
import WhatWeGotWrongInMonthOne from './blog/WhatWeGotWrongInMonthOne';
import Toronto from './locations/Toronto';
import Mississauga from './locations/Mississauga';
import Hamilton from './locations/Hamilton';
import GTA from './locations/GTA';
import Ottawa from './locations/Ottawa';
import KitchenerWaterloo from './locations/KitchenerWaterloo';
import Approve from './Approve';
import AdminRerender from './AdminRerender';
import { usePixelPageView } from './content/usePixelPageView';
import { useGAPageView } from './content/useGAPageView';

function PixelPageViewTracker() {
  usePixelPageView();
  return null;
}

function GAPageViewTracker() {
  useGAPageView();
  return null;
}

function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    });
  }, [hash]);

  return (
    <>
      <Nav />
      <Hero />
      <SocialProof />
      <TwoAudiences />
      <SteelSupply />
      <HowItWorksSection />
      <Services />
      <SubmitForm />
      <Pricing />
      <Manufacturers />
      <FAQ />
      <CTABanner />
      <Footer />
      <MobileStickyCTA />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <PixelPageViewTracker />
      <GAPageViewTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/how-to-get-custom-metal-parts-made-ontario" element={<HowToGetCustomMetalParts />} />
        <Route path="/blog/custom-metal-fabrication-cost-canada" element={<CustomMetalFabricationCost />} />
        <Route path="/blog/how-to-prototype-metal-product-ontario" element={<PrototypeMetalProduct />} />
        <Route path="/blog/sheet-metal-vs-cnc-machining" element={<SheetMetalVsCNC />} />
        <Route path="/blog/what-we-got-wrong-in-month-one" element={<WhatWeGotWrongInMonthOne />} />
        <Route path="/metal-fabrication-toronto" element={<Toronto />} />
        <Route path="/metal-fabrication-mississauga" element={<Mississauga />} />
        <Route path="/metal-fabrication-hamilton" element={<Hamilton />} />
        <Route path="/metal-fabrication-gta" element={<GTA />} />
        <Route path="/metal-fabrication-ottawa" element={<Ottawa />} />
        <Route path="/metal-fabrication-kitchener-waterloo" element={<KitchenerWaterloo />} />
        <Route path="/approve" element={<Approve />} />
        <Route path="/admin/rerender" element={<AdminRerender />} />
      </Routes>
    </BrowserRouter>
  );
}
